// Curated landing pages, not every incidental article keyword. Existing tag
// URLs remain usable; only substantive multi-article collections are indexed.
export const topicIntroductions: Record<string, string> = {
  authentication:
    'Start with identity and access control, then compare server sessions, JWTs and delegated sign-in. These articles separate the user identity from the permissions and token lifecycles an application must enforce.',
  authorization:
    'Explore the boundary between identifying a user and allowing an action. Follow the request lifecycle and compare permission models, enforcement points and common access-control mistakes.',
  security:
    'Read about authentication, browser and transport security as connected boundaries. Begin with the threat or failure mode, then follow the controls and tradeoffs through the application.',
  backend:
    'Follow a request through proxies, middleware, authentication and application logic. These articles connect backend mechanisms to the debugging and security decisions behind a working web application.',
  networking:
    'Trace the path from a URL to a server response. Read the request overview first, then explore DNS, transport security and HTTP in more detail.',
  'web-performance':
    'Connect the browser rendering pipeline with the network and server work that precedes it. Use these articles to distinguish slow delivery, rendering delays and hydration problems before choosing an optimization.',
}

export function isIndexableTopic(tag: string, count: number) {
  return count >= 2 && Object.hasOwn(topicIntroductions, tag)
}
